import { render, staticRenderFns } from "./FormInputPass.vue?vue&type=template&id=b323bd6a&scoped=true&"
import script from "./FormInputPass.vue?vue&type=script&lang=js&"
export * from "./FormInputPass.vue?vue&type=script&lang=js&"
import style0 from "./FormInputPass.vue?vue&type=style&index=0&id=b323bd6a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b323bd6a",
  null
  
)

export default component.exports